<template>
	<div id="botList">
		<div class="list-container">
			<div v-if="listData.length === 0" class="empty-list">
				<p>暂无数据</p>
			</div>

			<div v-for="(item, index) in listData" :key="index" class="list-item"
				:class="{ 'expanded': item.expanded }">
				<div class="item-header" @click="toggleExpand(index)">
					<div class="profile-header">
						<div class="avatar-section">
							<div class="avatar-container">
								<file-upload class="avatar-uploader" :action="`/file/upload/botImage?id=${item.id}&thumbSize=20`"
									:isPermanent="true" :showLoading="true" :maxSize="maxSize"
									@success="onUploadSuccess" m-type="image"
									:fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp']">
									<head-image class="avatar" :size="60" :url="item.headImageThumb" radius="50%"
										:name="item.nickName || item.userName">
									</head-image>
								</file-upload>
								<!-- 悬浮提示涂层 -->
								<div class="upload-overlay">
									<i class="el-icon-camera"></i>
									<span>更换头像</span>
								</div>
							</div>
						</div>
						<div class="user-basic-info">
							<h3 class="user-name">
								{{ item.nickName || item.userName || '未设置昵称' }}
								<span class="company-tag" v-if="item.companyName">@{{ item.companyName }}</span>
							</h3>
							<p class="user-id">ID: {{ item.userName || '未知用户' }}</p>
							<p class="api-key">API Key: {{ item.apiKey }}</p>
						</div>
					</div>
					<div class="item-actions">
						<button style="margin-right: 10px;" @click="toggleStatus(index)"
							:class="['btn', item.status === 0 ? 'btn-warning' : 'btn-success']">
							{{ item.status === 0 ? '停用' : '启用' }}
						</button>
						<button style="margin-right: 10px;" @click.stop="openEditModal(index)"
							class="btn btn-primary">编辑</button>
						<button style="margin-right: 10px;" @click.stop="delApiKey(index)"
							class="btn btn-primary">重置</button>
						<button @click.stop="deleteItem(index)" class="btn btn-danger">删除</button>
					</div>
				</div>

				<div v-if="item.expanded" class="sub-list">
					<ul>
						<li v-for="(subItem, subIndex) in item.tgbotList" :key="subIndex">
							{{ subItem }}
						</li>
					</ul>
				</div>
			</div>
		</div>

		<div class="create-btn-container">
			<button @click="openCreateModal" class="create-btn">创 建</button>
		</div>

		<!-- 编辑/创建弹窗 -->
		<div v-if="showModal" class="modal" @click="closeModal">
			<div class="modal-content" @click.stop>
				<div class="modal-header">
					<h2>{{ isEditing ? '编辑项目' : '创建新项目' }}</h2>
					<button class="close-btn" @click="closeModal">&times;</button>
				</div>
				<div class="modal-body">
					<form @submit.prevent="saveItem">
						<input id="apiKey" v-model="currentItem.apiKey" type="hidden">
						<div class="form-group">
							<label for="nickName">昵称</label>
							<input id="nickName" v-model="currentItem.nickName" type="text">
						</div>
						<div class="form-group">
							<label for="tdToken">TgToken</label>
							<input id="tdToken" v-model="currentItem.tdToken" type="text">
						</div>
						<div class="form-group">
							<label for="callBackUrl">回调URL</label>
							<input id="callBackUrl" v-model="currentItem.callBackUrl" type="url">
						</div>
						<div class="form-group">
							<label for="status">状态</label>
							<select id="status" v-model="currentItem.status">
								<option value="0">启用</option>
								<option value="1">停用</option>
							</select>
						</div>
					</form>
				</div>
				<div class="modal-footer">
					<button @click="closeModal" class="btn btn-secondary">取消</button>
					<button @click="saveItem" class="btn btn-primary">保存</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import FileUpload from "../common/FileUpload.vue";
import HeadImage from "../common/HeadImage.vue";
export default {
	name: "botSetting",
	components: {
		FileUpload,
		HeadImage
	},
	mounted() {
	    this.init();
	},
	data() {
		return {
			maxSize: 5 * 1024 * 1024,
			inited:false,
			listData: [],
			showModal: false,
			isEditing: false,
			editIndex: null,
			currentItem: {
				type: 0,
				apiKey: '',
				tdToken: '',
				callBackUrl: '',
				status: 0
			}
		};
	},
	methods: {
		init() {
			if(!this.inited){
				this.loadData();
			}
			this.inited = true;
		},
		loadData(){
			//初始化
			this.$http({
			    url: "/bot/list",
			    method: "get"
			}).then((data) => {
				this.listData = data;
			})
		},
		toggleExpand(index) {
			if(this.listData[index].tgbotList && this.listData[index].tgbotList.length>0){
				this.listData[index].expanded = !this.listData[index].expanded;
			}
		},
		toggleStatus(index) {
			const item = this.listData[index];
			item.status = item.status === 1 ? 0 : 1;
			//提交到后端（update）
			this.$http({
			    url: "/bot/update",
			    method: "post",
				data: this.listData[index]
			}).then((data) => {
				this.loadData();
				this.$message.success("修改成功");
			})
		},
		onUploadSuccess(data, file) {
		    // this.userInfo.headImage = data.originUrl;
		    // this.userInfo.headImageThumb = data.thumbUrl;
		    // // 更新 userStore 中的用户信息
		    // this.userStore.userInfo.headImage = data.originUrl;
		    // this.userStore.userInfo.headImageThumb = data.thumbUrl;
		},
		openCreateModal() {
			this.isEditing = false;
			this.currentItem = {
				type: 0,
				apiKey: '',
				tdToken: '',
				callBackUrl: '',
				status: '0'
			};
			this.showModal = true;
		},
		openEditModal(index) {
			this.isEditing = true;
			this.editIndex = index;
			this.currentItem = {
				...this.listData[index]
			};
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
		},
		saveItem() {
			//提交到后端（create or update）
			if(this.currentItem.tdToken!=undefined && this.currentItem.tdToken!=""){
				this.currentItem.type = 1;
			}
			if (this.isEditing) {
				this.$http({
				    url: "/bot/update",
				    method: "post",
					data: this.currentItem
				}).then((data) => {
					this.loadData();
					this.$message.success("修改成功");
				})
			} else {
				this.$http({
				    url: "/bot/create",
				    method: "post",
					data: this.currentItem
				}).then((data) => {
					this.loadData();
					this.$message.success("保存成功");
				})
			}
			//提交到后端（create or update）
			this.closeModal();
		},
		delApiKey(index) {
			if (confirm('确定要这个项目的apiKey吗？')) {
				this.listData[index].apiKey='';
				//提交到后端（update）
				this.$http({
				    url: "/bot/update",
				    method: "post",
					data: this.listData[index]
				}).then((data) => {
					console.log(data);
					this.listData[index].apiKey=data;
					this.$message.success("修改成功");
				})
			}
		},
		deleteItem(index) {
			if (confirm('确定要删除这个项目吗？')) {
				//提交到后端（delete）
				this.$http({
				    url: "/bot/remove",
				    method: "post",
					data: this.listData[index]
				}).then((data) => {
					this.listData.splice(index, 1);
					this.$message.success("删除成功");
				})
			}
		}
	}
}
</script>

<style scoped lang="scss">
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}

	body {
		font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
		background-color: #f5f7fa;
		color: #333;
		line-height: 1.6;
	}

	#botList {
		max-width: 1000px;
		margin: 30px auto;
		padding: 20px;
		background: #fff;
		border-radius: 10px;
		box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
	}
	.profile-header {
	    display: flex;
	    align-items: center;
	    gap: 25px;
	
	    .avatar-section {
	        .avatar-container {
	            position: relative;
	            width: 60px;
	            height: 60px;
	
	            .avatar-uploader {
	                --width: 60px;
	
	                .el-upload {
	                    border: 2px dashed rgba(0, 0, 0, 0.1) !important;
	                    border-radius: 50%;
	                    cursor: pointer;
	                    position: relative;
	                    overflow: hidden;
	                    transition: all 0.3s ease;
	                    width: var(--width);
	                    height: var(--width);
	
	                    &:hover {
	                        border-color: var(--im-color-primary) !important;
	                        transform: scale(1.05);
	                    }
	                }
	
	                .avatar {
	                    width: var(--width);
	                    height: var(--width);
	                    display: block;
	                    border-radius: 50%;
	                }
	            }
	
	            // 悬浮提示涂层
	            .upload-overlay {
	                position: absolute;
	                top: 0;
	                left: 0;
	                width: 60px;
	                height: 60px;
	                background: rgba(0, 0, 0, 0.5);
	                border-radius: 50%;
	                display: flex;
	                flex-direction: column;
	                align-items: center;
	                justify-content: center;
	                color: white;
	                font-size: 12px;
	                opacity: 0;
	                transition: opacity 0.3s ease;
	                pointer-events: none;
	                z-index: 10;
	
	                i {
	                    font-size: 18px;
	                    margin-bottom: 2px;
	                }
	            }
	
	            &:hover .upload-overlay {
	                opacity: 1;
	            }
	        }
	    }
	
	    .user-basic-info {
	        flex: 1;
	        text-align: left;
	
	        .user-name {
	            margin: 0 0 6px 0;
	            font-size: 20px;
	            font-weight: 600;
	            color: var(--im-text-color-primary);
	        }
	
	        .user-id {
	            margin: 0;
	            font-size: 14px;
	            color: var(--im-text-color-light);
	            font-family: 'Courier New', monospace;
	        }
			.api-key {
			    margin-top: 10px;
			    font-size: 14px;
			    color: var(--im-text-color-light);
			    font-family: 'Courier New', monospace;
			}
	    }
	}

	.list-container {
		border: 1px solid #e1e8ed;
		border-radius: 8px;
		overflow: hidden;
	}

	.list-item {
		border-bottom: 1px solid #e1e8ed;
		transition: background-color 0.3s;
	}

	.list-item:last-child {
		border-bottom: none;
	}

	.item-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 15px 20px;
		cursor: pointer;
		background-color: #fff;
		transition: background-color 0.3s;
	}

	.item-header:hover {
		background-color: #f8f9fa;
	}

	.item-info {
		display: flex;
		gap: 20px;
	}

	.item-field {
		font-weight: 500;
	}

	.item-field.api-key {
		color: #7f8c8d;
		font-size: 14px;
		max-width: 200px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.item-status {
		padding: 4px 10px;
		border-radius: 20px;
		font-size: 12px;
		font-weight: bold;
	}

	.status-enabled {
		background-color: #e8f5e9;
		color: #2e7d32;
	}

	.status-disabled {
		background-color: #ffebee;
		color: #c62828;
	}

	.expand-icon {
		margin-left: 10px;
		transition: transform 0.3s;
	}

	.expanded .expand-icon {
		transform: rotate(180deg);
	}

	.sub-list {
		padding: 0 20px 15px 40px;
		background-color: #f8f9fa;
	}

	.sub-list ul {
		list-style-type: none;
	}

	.sub-list li {
		padding: 8px 0;
		border-bottom: 1px dashed #ddd;
		color: #555;
	}

	.sub-list li:last-child {
		border-bottom: none;
	}

	.actions {
		display: flex;
		justify-content: flex-end;
		gap: 10px;
		padding: 15px 20px;
		background-color: #f8f9fa;
	}

	.btn {
		padding: 6px 12px;
		border: none;
		border-radius: 4px;
		cursor: pointer;
		font-size: 14px;
		transition: all 0.3s;
	}

	.btn-primary {
		background-color: #3498db;
		color: white;
	}

	.btn-primary:hover {
		background-color: #2980b9;
	}

	.btn-success {
		background-color: #2ecc71;
		color: white;
	}

	.btn-success:hover {
		background-color: #27ae60;
	}

	.btn-warning {
		background-color: #f39c12;
		color: white;
	}

	.btn-warning:hover {
		background-color: #d35400;
	}

	.btn-danger {
		background-color: #e74c3c;
		color: white;
	}

	.btn-danger:hover {
		background-color: #c0392b;
	}

	.create-btn-container {
		text-align: center;
		margin-top: 30px;
	}

	.create-btn {
		padding: 12px 30px;
		background-color: #9b59b6;
		color: white;
		border: none;
		border-radius: 30px;
		font-size: 16px;
		cursor: pointer;
		transition: all 0.3s;
		box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
	}

	.create-btn:hover {
		background-color: #8e44ad;
		transform: translateY(-2px);
		box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
	}

	.modal {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 1000;
	}

	.modal-content {
		background-color: white;
		border-radius: 8px;
		width: 90%;
		max-width: 500px;
		box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
		animation: modalOpen 0.3s ease-out;
	}

	@keyframes modalOpen {
		from {
			opacity: 0;
			transform: translateY(-50px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	.modal-header {
		padding: 20px;
		border-bottom: 1px solid #eee;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.modal-header h2 {
		margin: 0;
		color: #2c3e50;
	}

	.close-btn {
		background: none;
		border: none;
		font-size: 24px;
		cursor: pointer;
		color: #aaa;
		transition: color 0.3s;
	}

	.close-btn:hover {
		color: #333;
	}

	.modal-body {
		padding: 20px;
	}

	.form-group {
		margin-bottom: 20px;
	}

	.form-group label {
		display: block;
		margin-bottom: 5px;
		font-weight: 500;
		color: #555;
	}

	.form-group input,
	.form-group select {
		width: 100%;
		padding: 10px;
		border: 1px solid #ddd;
		border-radius: 4px;
		font-size: 14px;
	}

	.form-group input:focus,
	.form-group select:focus {
		outline: none;
		border-color: #3498db;
		box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
	}

	.modal-footer {
		padding: 15px 20px;
		border-top: 1px solid #eee;
		display: flex;
		justify-content: flex-end;
		gap: 10px;
	}

	.empty-list {
		text-align: center;
		padding: 40px 20px;
		color: #7f8c8d;
	}

	.empty-list p {
		font-size: 18px;
		margin-bottom: 20px;
	}
</style>